import { render, staticRenderFns } from "./class-check.vue?vue&type=template&id=1e836f6e&scoped=true&"
import script from "./class-check.vue?vue&type=script&lang=ts&"
export * from "./class-check.vue?vue&type=script&lang=ts&"
import style0 from "./class-check.vue?vue&type=style&index=0&id=1e836f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e836f6e",
  null
  
)

export default component.exports